import { Link, useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import Header from "../../Common/Layout/Header";
import SideBar from "../../Common/Layout/Sidebar";
import UserTab from "./UserTab";

const initialFieldValues = {
    applicationLenderId: "00000000-0000-0000-0000-000000000000",
    lendingApplicationId: "00000000-0000-0000-0000-000000000000",
    lenderId: "00000000-0000-0000-0000-000000000000",
    status: "ELIGIBLE",
    amount: 0
};

export default function ClientPhoneNumbers() {
    const params = useParams();
    const navigate = useNavigate(); // Add useNavigate hook
    const [loading, setLoading] = useState(false);
    const [phoneNumbers, setPhoneNumbers] = useState([]);
    const [errors, setErrors] = useState({});
    const [loadingStates, setLoadingStates] = useState({});
    
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken")
        }
    }

    const handleSubmit = (e, data) => {
        e.preventDefault();
        const formData = {
            "userId": localStorage.getItem("userId"),
            "phoneNumber": "+" + data.number,
            "region": data.region + "," + data.country
        }
        
        setLoadingStates(prev => ({ ...prev, [data.number]: true }));
        addOrEdit(formData, data.number);
    };

    const applicationAPI = () => {
        return {
            add: (updateRecord) => axios.post(config.APIACTIVATEURL + config.BUYCLIENTPHONENUMBER, updateRecord, { ...headerconfig })
        };
    };

    const addOrEdit = (formData, phoneNumber) => {
        applicationAPI()
            .add(formData)
            .then((res) => {
                if (res.data.statusCode === 200) {
                    handleSuccess("Phone number successfully added");
                    GetPhoneNumbers();
                    // Redirect to profile page after successful selection
                    navigate('/userdashboard/profile');
                } else {
                    handleError(res.data.message);
                }
            })
            .catch(function (error) {
                handleError("Error in updating data");
            })
            .finally(() => {
                setLoadingStates(prev => ({ ...prev, [phoneNumber]: false }));
            });
    };

    const GetPhoneNumbers = () => {
        setLoading(true);
        axios
            .get(config.APIACTIVATEURL + config.GETCLIENTPHONENUMBERS, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setPhoneNumbers(response.data.data);
                }
                setLoading(false);
            });
    };

    useEffect(() => {
        GetPhoneNumbers();
    }, [])

    return (
        <div id="layout-wrapper">
            <Header></Header>
            <SideBar></SideBar>
            <div className="body-wrapper">
                <div className="content-fluid">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-12 mb-2">
                                    <h5>Choose a phone number marketing</h5>
                                </div>
                                <div className="col-lg-12">
                                    <div className="table-responsive">
                                        <table className="table table-borderless align-middle mb-0">
                                            <thead className="table-light">
                                                <tr className="text-left">
                                                    <th>Id</th>
                                                    <th scope="col">PhoneNumber</th>
                                                    <th scope="col">Region</th>
                                                    <th scope="col">SMS</th>
                                                    <th scope="col">Voice</th>
                                                    <th scope="col">MMS</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            {loading === true ?
                                                <tbody>
                                                    <tr>
                                                        <td colSpan="8">Loading...</td>
                                                    </tr>
                                                </tbody>
                                                :
                                                <tbody className="text-left">
                                                    {phoneNumbers.length > 0 && phoneNumbers.map((d, index) =>
                                                        <tr key={d.number}>
                                                            <td>{index + 1}</td>
                                                            <td>+{d.number}</td>
                                                            <td>{d.region}, {d.country}</td>
                                                            <td>Enabled : {d.smsEnabled === true ? "YES" : "NO"}</td>
                                                            <td>Enabled : {d.voiceEnabled === true ? "YES" : "NO"}</td>
                                                            <td>Enabled : {d.mmsEnabled === true ? "YES" : "NO"}</td>
                                                            <td>
                                                                <button 
                                                                    className="btn btn-primary" 
                                                                    onClick={(e) => handleSubmit(e, d)}
                                                                    disabled={loadingStates[d.number]}
                                                                >
                                                                    {loadingStates[d.number] ? "Processing..." : "Select"}
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            }
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}